<template>
  <div class="client-select" v-click-outside="close">
    <input
      type="text"
      class="input"
      :placeholder="placeholder"
      v-model="query"
      @focus="onFocus"
      @input="open = true"
    />
    <div v-if="open" class="client-select__list">
      <template v-if="filtered.length">
        <div
          v-for="c in filtered"
          :key="c.id"
          class="client-select__item"
          @mousedown.prevent="select(c)"
        >
          <span class="client-select__alias">{{ c.alias }}</span>
          <span class="client-select__local">({{ localName(c) }})</span>
        </div>
      </template>
      <div v-else class="client-select__empty">Sin resultados</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientSelect',
  props: {
    clients: { type: Array, required: true },
    modelValue: { type: Object, default: null },
    placeholder: { type: String, default: 'Buscar inquilino' }
  },
  emits: ['update:modelValue'],
  directives: {
    clickOutside: {
      beforeMount (el, binding) {
        el._clickOutside = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value()
          }
        }
        document.addEventListener('click', el._clickOutside)
      },
      unmounted (el) {
        document.removeEventListener('click', el._clickOutside)
      }
    }
  },
  data () {
    return {
      query: '',
      open: false
    }
  },
  computed: {
    currentLabel () {
      return this.modelValue && this.modelValue.alias ? this.label(this.modelValue) : ''
    },
    filtered () {
      const q = this.query.trim().toLowerCase()
      if (!q || q === this.currentLabel.toLowerCase()) return this.clients
      return this.clients.filter(c => {
        const alias = (c.alias || '').toLowerCase()
        const name = (c.name || '').toLowerCase()
        const local = this.localName(c).toLowerCase()
        return alias.includes(q) || name.includes(q) || local.includes(q)
      })
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler (value) {
        this.query = value && value.alias ? this.label(value) : ''
      }
    }
  },
  methods: {
    label (c) {
      return `${c.alias} (${this.localName(c)})`
    },
    localName (c) {
      return (c && c.local && c.local.description) || 'Sin local'
    },
    select (c) {
      this.$emit('update:modelValue', c)
      this.query = this.label(c)
      this.open = false
    },
    onFocus (event) {
      this.open = true
      event.target.select()
    },
    close () {
      this.open = false
      this.query = this.currentLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.client-select {
  position: relative;

  &__list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    max-height: 260px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    z-index: 10;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f2f2f2;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f7f7f7;
    }
  }

  &__alias {
    font-weight: 600;
  }

  &__local {
    color: #777;
    font-size: 0.9em;
  }

  &__empty {
    padding: 12px;
    text-align: center;
    color: #999;
  }
}
</style>
